import React from "react";

import { RowActionButton } from "../../../components/toolbars/RowActionButton";
import { ClientNotificationDeliveryStatus } from "../../../entities/ClientNotificationDeliveryStatus";


const isReplayable = (record) => record.status === ClientNotificationDeliveryStatus.failed;

export const ReplayButton = ({ resource, record }) => (
	<RowActionButton
		resource={resource}
		record={record}
		action="replay"
		label="osfc.buttons.replay"
		tooltip={`resources.${resource}.replay.tooltip`}
		isEnabled={isReplayable}
	/>
);
